import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Spinner, { SPINNER_TYPE } from "../../common-components/Spinner";
import { Duration } from "./shorts-components";
import { secondsToMinute } from "../timeline/timeline-helper";

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 25;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: inherit;
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SpinnerWrap = styled.div`
  height: 50px;
  width: 75px;
`;

/**
 * Left workspace overlay while Apply AI Reframe runs (driven by shorts-content
 * via SET_REFRAME_LOADING → isReframeApplying in shorts-player).
 */
const WorkspaceReframeLoader = ({ duration = 0 }) => {
  return (
    <Overlay>
      <Duration
        left="8px"
        right="auto"
        style={{
          width: "fit-content",
          padding: "0px 6px",
          zIndex: 26,
        }}
      >
        {secondsToMinute(0)}
        {" / "}
        {secondsToMinute(duration)}
      </Duration>
      <SpinnerWrap>
        <Spinner type={SPINNER_TYPE.ELLIPSIS_SPINNER} />
      </SpinnerWrap>
    </Overlay>
  );
};

WorkspaceReframeLoader.propTypes = {
  duration: PropTypes.number,
};

export default WorkspaceReframeLoader;
